import React from 'react';
import {toPriceStr} from '@/utils';
import {useTranslation} from 'react-i18next';
import {ReactComponent as CopyLink} from '@/components/assets/icons/copylink.svg';

const closeIcon = require('@assets/icons/close.webp');
const thirdShares: {label: string; icon?: string}[] = [
  {
    label: 'Facebook',
    icon: require('@components/assets/icons/facebook.webp'),
  },
  {
    label: 'Telegram',
    icon: require('@components/assets/icons/tg.webp'),
  },
  {
    label: 'Whatsapp',
    icon: require('@components/assets/icons/whatsapp.webp'),
  },
  {
    label: 'Instagram',
    icon: require('@components/assets/icons/insgram.webp'),
  },
  {label: 'CopyLink'},
];

export default function SharePanel({
  hasReward = false,
  onItemPress = () => {},
  onClose = () => {},
  inviteCode,
  description,
  onCopyInviteCode,
}: {
  onItemPress: (platform: string) => void;
  onClose: () => void;
  inviteCode: string;
  description?: string;
  onCopyInviteCode: () => void;
  hasReward: boolean;
}) {
  const {i18n} = useTranslation();

  return (
    <div className="flex flex-col rounded-t-[16px] bg-white [font-family:Inter] text-[12px] font-normal leading-[normal] tracking-[-0.3px] text-t2">
      <div className="relative flex h-[58px] shrink-0 items-center justify-center">
        <span className="text-[18px] font-normal leading-[normal] [font-family:Inter-Bold]">
          {i18n.t('bets-share.label.share')}
        </span>
        <button
          type="button"
          aria-label={i18n.t('share.close')}
          className="absolute left-[16px] top-[19px] m-0 border-0 bg-transparent p-0 active:opacity-80 focus:ring-2 focus:ring-inset focus:ring-current"
          onClick={onClose}>
          <img
            src={closeIcon}
            alt=""
            className="block h-[20px] w-[20px] object-contain"
          />
        </button>
      </div>
      {description ? (
        <p className="mx-4 mb-0 mt-2 text-center text-xs leading-[18px] text-[#656B78]">
          {description}
        </p>
      ) : null}
      <div className="flex overflow-x-auto overflow-y-hidden py-[24px]">
        <div className="flex shrink-0 pr-[24px]">
          {thirdShares.map((item, index) => (
            <button
              type="button"
              key={item.label}
              onClick={() => onItemPress(item.label)}
              className="m-0 ml-[24px] flex shrink-0 flex-col items-center border-0 bg-transparent p-0 text-inherit active:opacity-80 focus:ring-2 focus:ring-inset focus:ring-current">
              {item.icon ? (
                <img
                  src={item.icon}
                  alt=""
                  className="block h-[48px] w-[48px] object-contain"
                />
              ) : (
                <CopyLink className="h-[48px] w-[48px]" aria-hidden="true" />
              )}
              <span className="mt-[4px] whitespace-nowrap text-left">
                {item.label}
              </span>
              <span className="text-[14px] font-normal leading-[normal] text-[#F15802] [font-family:Inter-Bold]">
                {index === 0 && hasReward ? '+ ' : ''}
                {index === 0 && hasReward
                  ? toPriceStr(1, {
                      fixed: 0,
                      showCurrency: true,
                      thousands: true,
                    })
                  : ''}
              </span>
            </button>
          ))}
        </div>
      </div>
      {inviteCode ? (
        <div className="mx-[16px] mb-[16px] flex min-h-[64px] items-center rounded-[22px] bg-[#F4F5F8] px-[14px]">
          <div className="mr-[12px] flex h-[32px] w-[40px] shrink-0 items-center justify-center rounded-[16px] bg-[#E6E8EF]">
            <img
              src={require('@assets/imgs/invitation/log.webp')}
              alt=""
              className="block h-[22px] w-[22px] object-contain"
            />
          </div>
          <div className="min-w-0 flex-1">
            <div className="text-[12px] font-semibold leading-[15px] text-[#656B78]">
              {i18n.t('login.tip.referral-code')}
            </div>
            <div className="mt-[2px] text-[16px] font-bold leading-[21px] text-[#1C9B83]">
              {inviteCode}
            </div>
          </div>
          <button
            type="button"
            aria-label={i18n.t('login.tip.referral-code')}
            className="m-0 ml-[8px] flex h-[40px] w-[40px] shrink-0 items-center justify-center border-0 bg-transparent p-0 active:opacity-80 focus:ring-2 focus:ring-inset focus:ring-current"
            onClick={onCopyInviteCode}>
            <img
              src={require('@assets/imgs/invitation/logCopy.webp')}
              alt=""
              className="block h-[24px] w-[24px] object-contain"
            />
          </button>
        </div>
      ) : null}
    </div>
  );
}
